import { Component, OnInit } from '@angular/core';
import {Publicite} from '../../../shared/components/models/publicite';
import {PubliciteService} from '../../../core/services/publicite.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-pub-f',
  templateUrl: './pub-f.component.html',
  styleUrls: ['./pub-f.component.scss']
})
export class PubFComponent implements OnInit {
  pubF: Publicite;
  publicites: Publicite[] = [];
  publiciteImageUri: string;
  constructor(private publiciteService: PubliciteService) {
    this.publiciteImageUri = environment.publiciteImageUri;
  }

  ngOnInit(): void {
    this.loadPublicite();
  }

  loadPublicite() {
    this.publiciteService.findPubF().subscribe(ret => {
      if (ret['status'] === 'OK') {
        this.publicites = ret['response'];
        // console.log(this.publicites);
        this.pubF = this.publicites.find(p=>p.type==='F');
      } else {
        // console.log('erreur survenu');
      }
    }, error => {
      console.log('erreur server');
    });
  }
}
